var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 11.125C46.5012 11.125 3.125 54.5168 3.125 108C3.125 161.514 46.5012 204.875 100 204.875C153.499 204.875 196.875 161.514 196.875 108C196.875 54.5168 153.499 11.125 100 11.125ZM100 54.0938C109.061 54.0938 116.406 61.4391 116.406 70.5C116.406 79.5609 109.061 86.9062 100 86.9062C90.9391 86.9062 83.5938 79.5609 83.5938 70.5C83.5938 61.4391 90.9391 54.0938 100 54.0938ZM121.875 153.312C121.875 155.901 119.776 158 117.188 158H82.8125C80.2238 158 78.125 155.901 78.125 153.312V143.938C78.125 141.349 80.2238 139.25 82.8125 139.25H87.5V114.25H82.8125C80.2238 114.25 78.125 112.151 78.125 109.562V100.188C78.125 97.5988 80.2238 95.5 82.8125 95.5H107.812C110.401 95.5 112.5 97.5988 112.5 100.188V139.25H117.188C119.776 139.25 121.875 141.349 121.875 143.938V153.312Z",
    fill: "#EAEAEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.00516a363abe73c17abccd9c33ff7342.svg";
export { ForwardRef as ReactComponent };